export default __webpack_public_path__ + "static/media/spider.15901f57.webp";